(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bio-grid"] && !Shopify.designMode) return;
  try {
    

const bios = document.getElementsByClassName('bio-item');


Array.from(bios).forEach(bio => {  
  bio.onclick = () => toggleBio(bio);
});

const toggleBio = function (bio) {
  if (bio.classList.contains('active')) {
    bio.classList.remove('active');  
  } else {
    Array.from(bios).forEach(bio => {  
      bio.classList.remove('active');  
    });
    bio.classList.add('active');    
  }
  
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
$(".mobMenu-toggle").click(function (event) {    
    $('#mobMenu').toggleClass("-translate-x-full").removeClass("opacity-0");    
    $(this).toggleClass("bg-black text-white").removeClass("opacity-0");    
  });



   $('header .nav a').mouseover(function (event) {
     var target = this.getAttribute('data-section');
     $(`header .sub-menu`).removeClass('visible');
    $(`header .menu-${target}`).toggleClass('visible');
  });  

  $('#mm .child-link').click(function (event) {
    event.preventDefault();    
    var currentPage = window.location.pathname;
    var clickTarget = event.target.getAttribute('href');
    var isSamePage = clickTarget.includes(currentPage);
    if (isSamePage) {
      $('body.index header').toggleClass("dark");    
      $('#mm').toggleClass("active"); 
      var targetId = event.target.hash.substr(1);
      const headerHeight = document.querySelector('header').clientHeight;
      const offsetTop = document.querySelector('#' + targetId + '').offsetTop;

      scroll({
        top: offsetTop - 85,
        behavior: 'smooth',
      });
    }  else {
      window.location.href = clickTarget;
    }  
  });

  $('header').mouseleave(function (event) {     
     $(`header .sub-menu`).removeClass('visible');
  });  

  $('#header-wrapper .search-toggle').click(function (event) {
    event.preventDefault();
    $('#header-wrapper .header-accounts').toggleClass('hidden');
    $('#header-wrapper .header-search').toggleClass('hidden');
    $('#header-wrapper .header-accounts').toggleClass('flex');
    $('#header-wrapper .header-search').toggleClass('flex');
  });

  $(".cartToggle").click(function (event) {
    event.preventDefault();
    $(".cartToggle").toggleClass("active");
    $('#side-cart').toggleClass("active");
  });

  // Mobile Menu
  $(".mobile-menu-toggle").click(function (event) {
    $('body.index header').toggleClass("dark");    
    $('#mm-mask').toggleClass("active");    
    $('#mm').toggleClass("active");        
  });

  $("#mm-mask").click(function (event) {
    $('body.index header').toggleClass("dark");    
    $('#mm-mask').toggleClass("active");    
    $('#mm').toggleClass("active");        
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", function(evt) {
      var note = evt.target.value;
      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: { 'cart-note': note } })
      };

      fetch('/cart/update.js', request);
    });
      
  }
}

customElements.define('cart-note', CartNote);

  Shopify.Cart = Shopify.Cart || {};
  
    Shopify.Cart.GiftWrap = {};
  
    Shopify.Cart.GiftWrap.set = function() {
      var headers = new Headers({ 'Content-Type': 'application/json' });
  
      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: { 'gift-wrapping': true } })
      };
      fetch('/cart/update.js', request)
      .then(function() {
        //location.href = '/cart';
      });
    }
  
    Shopify.Cart.GiftWrap.remove = function() {
      var headers = new Headers({ 'Content-Type': 'application/json' });
  
      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ attributes: { 'gift-wrapping': '', 'gift-note': '' } })
      };
      fetch('/cart/update.js', request)
      .then(function() {
        //location.href = '/cart';
      });
    }
    
    // When the gift-wrapping checkbox is checked or unchecked.
    document.addEventListener("DOMContentLoaded", function(){
    if (document.querySelector('[name="attributes[gift-wrapping]"]').checked) {
        document.querySelector('.gift-message').classList.add('active');
    }
      document.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", function(event) {
          event.preventDefault();
        if (event.target.checked) {
          Shopify.Cart.GiftWrap.set();
          document.querySelector('.gift-message').classList.add('active');
        } else {
          Shopify.Cart.GiftWrap.remove();
          document.querySelector('.gift-message').classList.remove('active');
        }
  
      });
  
      document.querySelector('#gift-note').addEventListener("change", function(evt) {
        var note = evt.target.value;
        var headers = new Headers({ 'Content-Type': 'application/json' });
  
        var request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ attributes: { 'gift-note': note } })
        };
  
        fetch('/cart/update.js', request);
      });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Recharge plans accordion
  const rechargePlanButtons = document.querySelectorAll('.show-plans__btn');

  Array.from(rechargePlanButtons).forEach((button) => {
    const wrap = button.closest('.sub_save__wrap');
    const panel = wrap ? wrap.querySelector('.recharge-plans__container') : null;
    const inner = panel ? panel.querySelector('.inner') : null;

    if (!panel || !inner) return;

    const setRechargeAccordionState = (isOpen) => {
      panel.style.maxHeight = isOpen ? `${inner.scrollHeight + 1}px` : '0px';
      button.classList.toggle('open', isOpen);
      button.classList.toggle('close', !isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    setRechargeAccordionState(false);

    button.addEventListener('click', () => {
      const isOpen = button.classList.contains('open');
      setRechargeAccordionState(!isOpen);
    });

  });

  // Quantity input sync
  const quantityButton = document.querySelectorAll('.quantity__button');
  const quantityInput = document.querySelector('.quantity__input');
  const hiddenQuantity = document.querySelector('.quantity__hidden');

  const syncQuantityInput = () => {
    if (!quantityInput || !hiddenQuantity) return;
    hiddenQuantity.value = quantityInput.value;
  };

  if (quantityInput) {
    quantityInput.addEventListener('change', syncQuantityInput);
    quantityInput.addEventListener('input', syncQuantityInput);
  }

  Array.from(quantityButton).forEach((button) => {
    button.addEventListener('click', () => {
      syncQuantityInput();
    });
  });
  

  // Dropdown Toggle
  const elements = document.getElementsByClassName('product-section-toggle');

  Array.from(elements).forEach((element) => {
    const handleToggle = function () {
      const target = event.target.getAttribute('data-section');
      document.querySelector('.section-dropdown.' + target + '').classList.toggle('active');
      element.classList.toggle('active');
    };

    element.onclick = () => handleToggle();
    element.addEventListener('keyup', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        const target = event.target.getAttribute('data-section');
        document.querySelector('.section-dropdown.' + target + '').classList.toggle('active');
        handleToggle();
      }
    });
  });

  // Product description read more
  const productDescRoot = document.querySelector('.product-description');
  if (productDescRoot) {
    const descToggle = productDescRoot.querySelector('.product-description__toggle');
    const descMore = productDescRoot.querySelector('.product-description__more');
    if (descToggle && descMore) {
      const labelOpen = descToggle.getAttribute('data-label-open') || 'Read more';
      const labelClose = descToggle.getAttribute('data-label-close') || 'Read less';
      const labelEl = descToggle.querySelector('.product-description__toggle-label');
      descToggle.addEventListener('click', () => {
        descMore.classList.toggle('active');
        descToggle.classList.toggle('active');
        const isOpen = descMore.classList.contains('active');
        descToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (labelEl) {
          labelEl.textContent = isOpen ? labelClose : labelOpen;
        }
      });
    }
  }

  // Product reviews accordion
  const productReviewsRoot = document.querySelector('.product-reviews');
  if (productReviewsRoot) {
    const reviewsToggle = productReviewsRoot.querySelector('.product-reviews__toggle');
    const reviewsPanel = productReviewsRoot.querySelector('.product-reviews__panel');
    const reviewsClose = productReviewsRoot.querySelector('.product-reviews__close');
    const isMobileReviews = window.matchMedia('(max-width: 996px)');

    if (reviewsToggle && reviewsPanel) {
      const setReviewsState = (isOpen) => {
        reviewsPanel.classList.toggle('active', isOpen);
        reviewsToggle.classList.toggle('active', isOpen);
        reviewsToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isMobileReviews.matches) {
          document.body.style.overflow = isOpen ? 'hidden' : '';
        } else {
          document.body.style.overflow = '';
        }
      };

      reviewsToggle.addEventListener('click', () => {
        setReviewsState(!reviewsPanel.classList.contains('active'));
      });

      if (reviewsClose) {
        reviewsClose.addEventListener('click', () => setReviewsState(false));
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && reviewsPanel.classList.contains('active')) {
          setReviewsState(false);
        }
      });

      isMobileReviews.addEventListener('change', () => {
        if (!isMobileReviews.matches) {
          document.body.style.overflow = '';
        }
      });
    }
  }

  // Image gallery

  let productImagesSwiper = null;

  const initProductGallerySwiper = () => {
    if (productImagesSwiper) return;
    const galleryContainer = document.querySelector('.product-gallery.swiper-container');
    if (!galleryContainer) return;
    if (typeof window.Swiper === 'undefined') return;

    try {
      productImagesSwiper = new Swiper('.product-gallery.swiper-container', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } catch (error) {}
  };

  initProductGallerySwiper();
  window.addEventListener('load', initProductGallerySwiper);
  window.addEventListener('pageshow', initProductGallerySwiper);
  document.addEventListener('shopify:section:load', initProductGallerySwiper);

  // Past Year Vintage Notes
  const vintages = document.getElementsByClassName('py-toggle');

  Array.from(vintages).forEach((el) => {
    el.onclick = () => toggleVintage(el);
  });

  const toggleVintage = function (el) {
    const target = el.getAttribute('data-target');
    el.classList.toggle('active');
  };

  // Desktop product select

  const productSelect = document.querySelector('.product-form__input');



  const productOptionsDesktop = document.querySelectorAll('.desktop-variant-option');

  Array.from(productOptionsDesktop).forEach((option) => {
    option.addEventListener('click', function (event) {
      const chosen = this.getAttribute('data-option');
      document.querySelector('.product-form__input select').value = chosen;
      document.querySelector('.product-form__input select').dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Hide mobile fixed form when footer enters viewport
  const initMobileFormFooterHide = () => {
    const mobileFormWrapper = document.querySelector('.product-form-desk .form-wrapper');
    const footer = document.querySelector('.footer');
    if (!mobileFormWrapper || !footer) return;

    mobileFormWrapper.style.transition = 'opacity .3s ease-in-out';

    const setFormHidden = (isHidden) => {
      mobileFormWrapper.style.opacity = isHidden ? '0' : '1';
      mobileFormWrapper.style.pointerEvents = isHidden ? 'none' : 'auto';
    };

    const isDesktop = () => window.matchMedia('(min-width: 996px)').matches;

    // iOS Safari fallback path using viewport math.
    const updateMobileFormVisibility = () => {
      if (isDesktop()) {
        mobileFormWrapper.style.opacity = '';
        mobileFormWrapper.style.pointerEvents = '';
        return;
      }

      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const footerRect = footer.getBoundingClientRect();
      const visibleFooterPx = Math.max(
        0,
        Math.min(footerRect.bottom, viewportHeight) - Math.max(footerRect.top, 0),
      );
      setFormHidden(visibleFooterPx > 20);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (isDesktop()) {
            mobileFormWrapper.style.opacity = '';
            mobileFormWrapper.style.pointerEvents = '';
            return;
          }

          const entry = entries[0];
          setFormHidden(!!entry && entry.isIntersecting);
        },
        {
          threshold: 0,
          root: null,
        },
      );
      observer.observe(footer);

      window.addEventListener('resize', updateMobileFormVisibility);
      window.addEventListener('orientationchange', updateMobileFormVisibility);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateMobileFormVisibility);
      }
      updateMobileFormVisibility();
    } else {
      updateMobileFormVisibility();
      window.addEventListener('scroll', updateMobileFormVisibility, { passive: true });
      window.addEventListener('resize', updateMobileFormVisibility);
      window.addEventListener('orientationchange', updateMobileFormVisibility);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateMobileFormVisibility);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFormFooterHide);
  } else {
    initMobileFormFooterHide();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-menu-old"]) return;
  try {
    
$(".mobile-menu-toggle").click(function (event) {
    $('body.index header').toggleClass("dark");    
    $('#mm').toggleClass("active");        
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-collection"] && !Shopify.designMode) return;
  try {
    
const swiperRelated = new Swiper('.related-slider.swiper-container', {
  loop: false,
  pagination: {
    el: '.swiper-pagination',
  },
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1700: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  },
  
});


  } catch(e) { console.error(e); }
})();
})();
